import { useEffect, useState } from 'react'

import {
  getPopupStore,
  updatePopupStore
} from '../../../services/popupManagerService'

import {
  getOnboardingConfig,
  updateOnboardingConfig
} from '../../../services/settingsService'

import useLemonadeOnboarding from '../../../hooks/useLemonadeOnboarding'
import { useSelector } from 'react-redux'

export default function usePopupManager() {
  const [popupStore, setPopupStore] = useState(() => {
    const initialPopupStore = getPopupStore()

    // Aquí filtraremos los elementos que queremos quitar
    const filteredPopupStore = initialPopupStore.filter((popup) => {
      return (
        popup !== 'userLevelUp' &&
        popup !== 'onboardingLessonUnlocked' &&
        popup !== 'rewardBatteryUnlock'
      )
    })
    updatePopupStore(filteredPopupStore)
    return filteredPopupStore
  })
  const [onboarding, setOnboarding] = useState(getOnboardingConfig())
  const { lemonadeEmptyOnboarding } = useLemonadeOnboarding()
  const [pathSchool] = useState(
    useSelector((state) => state.configuration.pathSchool)
  )

  useEffect(() => {
    // ocLog('getconfig', getOnboardingConfig())
  }, [onboarding])

  function getFirstPopup() {
    const _tempStore = getPopupStore()
    // ocLog('showFirstPopup', _tempStore)
    return _tempStore[0]
  }

  function hasPopup() {
    const _tempStore = getPopupStore()
    // ocLog('hasPopup cola', _tempStore)
    return _tempStore.length > 0
  }

  function movePopupToLast(array, item) {
    if (array.includes(item)) {
      const index = array.indexOf(item)
      if (index !== -1) {
        array.splice(index, 1)
        array.push(item)
      }
    }
    return array
  }

  function movePopupToFirst(array, item) {
    if (array.includes(item)) {
      const index = array.indexOf(item)
      if (index !== -1) {
        array.splice(index, 1)
        array.unshift(item)
      }
    }
    return array
  }

  function pushPopup(item) {
    let _tempStore = getPopupStore()
    if (item === 'rewardBatteryUnlock') {
      const isExistLessonUnlocked = _tempStore.find(
        (itemTemp) => itemTemp === 'onboardingLessonUnlocked'
      )
      if (!isExistLessonUnlocked && !_tempStore.includes(item)) {
        _tempStore.push(item)
      }
    } else {
      _tempStore.push(item)
    }

    // El evento de primer onboarding debe ir antes que el de nuevas mascotas
    _tempStore = movePopupToLast(_tempStore, 'onboardingFirstUserLevel')

    _tempStore = movePopupToFirst(_tempStore, 'userLevelUp')

    // Comprobar que no salgan los dos popups de desbloqueo onboarding y normal a la vez

    updatePopupStore(_tempStore)
    setPopupStore(_tempStore)
  }

  function checkPopup() {
    const _tempStore = getPopupStore()
    _tempStore.shift()
    updatePopupStore(_tempStore)
    setPopupStore(_tempStore)
  }

  function resetPopupStore() {
    // ocLog('resetPopupStore')
    const _tempStore = []
    updatePopupStore(_tempStore)
    setPopupStore(_tempStore)
  }

  function hasOnboarding() {
    const onBoarding = getOnboardingConfig()
    delete onBoarding.lemonade
    const onboardingValues = Object.values(onBoarding)
    return onboardingValues.includes(1)
  }

  function resetOnboarding() {
    const _onboardingConfig = getOnboardingConfig()
    Object.keys(_onboardingConfig).forEach(function (key) {
      _onboardingConfig[key] = 0
    })
    _onboardingConfig.introduction = 1
    _onboardingConfig.lemonade = lemonadeEmptyOnboarding
    updateOnboardingConfig(_onboardingConfig)
    setOnboarding(_onboardingConfig)
    resetPopupStore()
  }

  // Onboarding events handlers

  // El evento ha sucedido, se mostrará al volver al mapa
  function pushOnboardingPanel(type, popupId) {
    const _onboardingConfig = getOnboardingConfig()
    if (_onboardingConfig[type] === 0) {
      _onboardingConfig[type] = 1
      updateOnboardingConfig(_onboardingConfig)
      setOnboarding(_onboardingConfig)
      pushPopup(popupId)
    }
  }

  // Se ha mostrado y hemos cerrado el mensaje
  function handleCheckOnboardingPanel(type) {
    // ocLog('CIERRA ONBOARDING: ', type)
    const _onboardingConfig = getOnboardingConfig()
    _onboardingConfig[type] = 2
    updateOnboardingConfig(_onboardingConfig)
    setOnboarding(_onboardingConfig)
    checkPopup()
  }

  function showIntroduction() {
    const _onboardingConfig = getOnboardingConfig()
    return _onboardingConfig.introduction === 1
  }

  function handleCheckIntroduction() {
    const _onboardingConfig = getOnboardingConfig()
    _onboardingConfig.introduction = 2
    updateOnboardingConfig(_onboardingConfig)
    setOnboarding(_onboardingConfig)
    // Muestra el onboarding de primeros movimientos
    pushOnboardingPanel('firstMoves', 'onboardingFirstMoves')
  }

  return {
    popupStore,
    resetPopupStore,
    getFirstPopup,
    pushPopup,
    checkPopup,
    hasPopup,
    onboarding,
    resetOnboarding,
    hasOnboarding,
    handleCheckIntroduction,
    pushOnboardingPanel,
    handleCheckOnboardingPanel,
    showIntroduction,
    pathSchool
  }
}
